import { Link } from "react-router-dom";
import { Trophy, MapPin, Calendar } from "lucide-react";

export function Footer() {
  return (
    <footer className="bg-slate-950 text-slate-300 noise">
      <div className="max-w-7xl mx-auto px-5 lg:px-8 py-16 grid gap-10 md:grid-cols-4">
        <div className="md:col-span-2">
          <div className="flex items-center gap-2.5 mb-4">
            <span className="grid place-items-center h-9 w-9 rounded-xl bg-sky-600 text-white"><Trophy size={18} /></span>
            <span className="font-display text-xl text-white">The Darren Power Memorial Golf Classic</span>
          </div>
          <p className="max-w-md text-sm text-slate-400 leading-relaxed font-display italic">
            "A true friend is never truly gone. His spirit lives on in the memories of those who love him."
          </p>
          <div className="mt-5 space-y-2 text-sm">
            <p className="flex items-center gap-2"><Calendar size={15} className="text-sky-400" /> Saturday 29th August 2026</p>
            <p className="flex items-center gap-2"><MapPin size={15} className="text-sky-400" /> Elmgreen Golf Club, Ashtown, Dublin</p>
          </div>
        </div>
        <div>
          <h4 className="text-white font-semibold mb-3 text-sm uppercase tracking-wider">Explore</h4>
          <ul className="space-y-2 text-sm">
            <li><Link to="/memorial" className="hover:text-sky-400 transition-colors">Memorial</Link></li>
            <li><Link to="/leaderboard" className="hover:text-sky-400 transition-colors">Leaderboard</Link></li>
            <li><Link to="/sponsors" className="hover:text-sky-400 transition-colors">Sponsors</Link></li>
            <li><Link to="/gallery" className="hover:text-sky-400 transition-colors">Gallery</Link></li>
          </ul>
        </div>
        <div>
          <h4 className="text-white font-semibold mb-3 text-sm uppercase tracking-wider">Take Part</h4>
          <ul className="space-y-2 text-sm">
            <li><Link to="/register" className="hover:text-sky-400 transition-colors">Enter the Classic</Link></li>
            <li><Link to="/donate" className="hover:text-sky-400 transition-colors">Donate</Link></li>
            <li><Link to="/faq" className="hover:text-sky-400 transition-colors">FAQs</Link></li>
            <li><Link to="/login" className="hover:text-sky-400 transition-colors">Organiser Login</Link></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-white/10 py-6 text-center text-xs text-slate-500">
        © {new Date().getFullYear()} The Darren Power Memorial Golf Classic · In loving memory of Pow
      </div>
    </footer>
  );
}
